import { requestOptions, HttpMethod } from "../../../utils/api/request-options";
import { handleResponse, handleResponseNoContent } from "../../../utils/api/response-handler";
import { StudentGroup, StudentGroupMember, GroupProgress } from "../model/stream";
export function getStudentGroups(streamId: number): Promise<StudentGroup[]> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/stream/${streamId}/studentgroup/list`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<StudentGroup[]>(response);
        });
}

export function getStudentGroup(streamId: number, groupId: number): Promise<StudentGroup> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/stream/${streamId}/studentgroup/${groupId}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<StudentGroup>(response);
        });
}

export function addStudentGroup(streamId: number, group: StudentGroup): Promise<StudentGroup> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/stream/${streamId}/studentgroup`, requestOptions(HttpMethod.POST, group))
        .then(response => {
            return handleResponse<StudentGroup>(response);
        });
}

export function updateStudentGroup(streamId: number, group: StudentGroup): Promise<StudentGroup> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/stream/${streamId}/studentgroup`, requestOptions(HttpMethod.PUT, group))
        .then(response => {
            return handleResponse<StudentGroup>(response);
        });
}

export function deleteStudentGroup(streamId: number, groupId: number): Promise<void> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/stream/${streamId}/studentgroup/${groupId}`, requestOptions(HttpMethod.DELETE))
        .then(response => {
            return handleResponseNoContent(response);
        });
}

export function getGroupMembers(groupId: number): Promise<StudentGroupMember[]> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/${groupId}/member/list`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<StudentGroupMember[]>(response);
        });
}

export function addGroupMember(groupId: number, member: StudentGroupMember): Promise<StudentGroupMember> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/${groupId}/member/${member.studentId}`, requestOptions(HttpMethod.POST))
        .then(response => {
            return handleResponse<StudentGroupMember>(response);
        });
}

export function removeGroupMember(groupId: number, memberId: number): Promise<void> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/${groupId}/member/${memberId}`, requestOptions(HttpMethod.DELETE))
        .then(response => {
            return handleResponseNoContent(response);
        });
}

export function getMyGroup(): Promise<StudentGroup> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/my-group`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<StudentGroup>(response);
        });
}

export function getStudentGroupByStudentId(studentId: number): Promise<StudentGroup> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/student/${studentId}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<StudentGroup>(response);
        });
}

export function getMyGroupProgress(): Promise<GroupProgress> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/group/my-group/progress`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<GroupProgress>(response);
        });
}
